import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import Table from '../../shared/Table'
import Button from '../../shared/Button';
import styles from './styles.scss';

export default class CompaniesListTable extends React.Component {
  static get propTypes() {
    return {
      companies: PropTypes.array,
      onChangeStatus: PropTypes.func,
    }
  }

  static get defaultProps() {
    return {
      companies: []
    }
  }

  get headers() {
    return [
      'Customer Number',
      'Company Name',
      'Company Status',
      'Subscription',
      'Rental Units',
      'Purchased Units',
      'Last Month Counter Total',
      'Current Month Counter Total',
      ''
    ];
  }

  get rows() {
    return this.props.companies.map((company) => ([
      company.customerNumber,
      company.name,
      company.enabled ? 'Active' : 'Inactive',
      company.subscription,
      company.rentalUnits,
      company.purchasedUnits,
      company.testsInPreviousMonth,
      company.testsInCurrentMonth,
      this.getActions(company.id, (company.enabled))
    ]));
  }

  getActions(companyId, enabled) {
    return (
      <div className='dropdown'>
        <Button
          className='dropdown-toggle'
          kind='borderless'
          data-toggle='dropdown'>
            Actions
        </Button>
        <div className='dropdown-menu dropdown-menu-left'>
          <Link
            to={{
              pathname:`/companies/${companyId}`,
              state: { editMode: true }
            }}
            className='dropdown-item'>
              <i className={`fa fa-pencil mr-2 ${styles.actionIcon}`}/>Edit
          </Link>
          <a
            className='dropdown-item'
            href="#"
            onClick={() => this.props.onChangeStatus(companyId, enabled)}
          >
            <i className={`fa fa-check-circle mr-2 ${styles.actionIcon}`}/>{enabled ? 'Deactivate' : 'Activate'}
          </a>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='text-center'>
        <Table headers={this.headers} rows={this.rows}/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/components/companiesList/CompaniesListTable/index.jsx